import React from 'react';
import styles from './styles.module.scss';

const ErrorScreen = () => {
  return (
    <div className={styles.wrapper} data-testid="error">
      <div className={styles.instruction}>
        <div>
          Oh no! We are unable to establish a connection due to a system error.
        </div>
        <br />
        <div>
          Please contact 1-833-697-3738 or support@peartherapeutics.com so we
          can resolve the issue.
        </div>
      </div>
      <div className={styles.pearError} />
    </div>
  );
};

export default ErrorScreen;
